import { OrganizationInvitationsState } from "@idw-types/state/organization-invitations-state";
import { getOrganizationInvitationsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getOrganizationInvitationsDataState = createSelector(getOrganizationInvitationsState, (state: OrganizationInvitationsState) => {
    return {
        isLoadingAxnAdminUserInvitations: state.organizationInvitations.isLoading,
        axnAdminUserInvitations: state.organizationInvitations.organizationInvitations
    };
});